import { render, staticRenderFns } from "./marketshare.vue?vue&type=template&id=120544c1"
import script from "./marketshare.vue?vue&type=script&lang=js"
export * from "./marketshare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports